export default __webpack_public_path__ + "static/media/legato_logo.227e72c7.png";